// extracted by mini-css-extract-plugin
module.exports = {"pagination":"CardsContainer_pagination__3OOof","active":"CardsContainer_active__1sy_s"};